export default function imageUploaderMapper(componentsData) {
  if (!componentsData) {
    return null;
  }
  const { buttonLabel, suggestedImagesLabel, suggestedImagesList = [], ...rest } = componentsData;
  return {
    ...rest,
    suggestedImagesLabel,
    buttonLabel,
    suggestedImagesList: suggestedImagesList.map(bullet => bullet.value),
  };
}
